import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FieldText from "../Components/Fields/FieldText";

import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import AlertComponent from "../Components/AlertComponent";
import { Row, Col } from "react-bootstrap";
import LeftLogo from "../Assets/Svgs/ai-image.svg";
import ChimpLogin from "../Assets/Svgs/dark-logo.svg";
import Image from "../Components/Image/image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import ArrowLeft from "../Assets/Images/arrow-left.svg";

function NotFound() {
  // <p style={{ color: 'white' }}>Oops... This page doesn't exists!</p>

  let navigate = useNavigate();
  const [email, setEmail] = useState(null);

  const handleSubmit = () => {
    const auth = getAuth();
    sendPasswordResetEmail(auth, email)
      .then(() => {
        AlertComponent("Success", "A reset password email has been sent.");
        return navigate("/", { replace: false });
      })
      .catch((error) => {
        return AlertComponent("Error", "Something went wrong. Try again later. " + error, { icon: `error` });
      });
  };

  const handleBack = () => {
    return navigate("/", { replace: false });
  };

  return (
    <div className="containerLoginForm">
      <Row className="login-body">
        <Col md={5}>
          <div className="containerLoginImage">
            <h2>Unlock the power of AI content with SocialChimp</h2>
            <h4>Chat with the smartest AI - Experience the power of AI with custom social generated content for all your needs.</h4>
            <img resizeMode="cover" src={LeftLogo} className="left-image-login" />
          </div>
        </Col>
        <Col md={7}>
          <div className="main-content">
            <div className="login-container">
              <Row style={{ justifyContent: "center" }}>
                <Image src={ChimpLogin} width={200} height={50} />
              </Row>
              <Row>
                <Col md={12}>
                  <div className="cs-login-form">
                    <form className="form-login">
                      <Row>
                        <div className="action-title">
                          <h5>Oops... This page doesn't exists!</h5>
                        </div>
                      </Row>

                      <div className="form-group mt-3 loginAlignCenter">
                        <button type="button" onClick={handleBack} className="btn submitLogin col-md-12">
                          Click here to back
                        </button>
                      </div>
                    </form>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default NotFound;
